import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ num, children }) => (
  <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-[var(--cash)]">
    <span className="text-zinc-400">{num}</span>
    <span className="h-px w-10 bg-[var(--cash)]" />
    <span>{children}</span>
  </div>
);
